import { createNavigation } from 'next-intl/navigation'
import { defineRouting } from 'next-intl/routing'

// Define routing with supported locales (lowercase for URLs)
export const routing = defineRouting({
  locales: ['en-us'],
  defaultLocale: 'en-us',
  localePrefix: 'always'
})

// Create navigation with the routing config
export const { Link, redirect, usePathname, useRouter } = createNavigation(routing)
